import { KineticHero } from "../components/KineticHero";
import { EditorialMarquee } from "../components/EditorialMarquee";
import { WhatIsGoox, CreatorFeatures, FanFeatures } from "../components/Features";
import { ExperienceEngine, HowItWorks } from "../components/Engine";
import { PlatformStatus } from "../components/PlatformStatus";
import { WaitlistForm } from "../components/WaitlistForm";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <KineticHero />
      <EditorialMarquee />
      <WhatIsGoox />
      <CreatorFeatures />
      <FanFeatures />
      <ExperienceEngine />
      <HowItWorks />
      <PlatformStatus />
      <WaitlistForm />
    </main>
  );
}
